import { useMemo } from "react";
import useCoverTint from "@/hooks/useCoverTint";
import type { ArcadeSong } from "@/utils/arcade/lineup";
import { arcadeThemeFor, type ArcadeTheme, type PaletteChoice } from "@/utils/arcade/theme";

// A song's arcade look: the cover's own tint when the CDN copy can be read,
// otherwise a colour seeded from the song, so a card and its game always match.
export function useSongTheme(song: ArcadeSong | null, choice: PaletteChoice = "cover"): ArcadeTheme | null {
  const tint = useCoverTint(song?.artwork);
  return useMemo(() => (song ? arcadeThemeFor(song, { coverTint: tint?.glow, choice }) : null), [song, tint?.glow, choice]);
}
